// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._5osap {\n  width: 33.33333%;\n}\n\n.YsHEp {\n  overflow: auto;\n}\n\n.maHd3 {\n  width: 83%;\n}\n\n.Wlgdz {\n  width: 200px;\n  height: 200px;\n  border-radius: var(--schoolinks-container-border-radius-medium);\n}\n\n.OpeWM {\n  font-weight: var(--font-weight-roboto-medium);\n  margin-bottom: var(--spacing-xxs);\n}\n\n@media screen and (max-width: 1020px) {\n  ._5osap {\n    width: 100%;\n  }\n\n  .CsAEo {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n  }\n}\n\n@media screen and (max-width: 560px) {\n  .maHd3 {\n    width: 100%;\n  }\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"third": "_5osap",
	"content": "YsHEp",
	"cardContainer": "maHd3",
	"logo": "Wlgdz",
	"sectionHeading": "OpeWM",
	"cardContents": "CsAEo"
};
export default ___CSS_LOADER_EXPORT___;
